import { createContext, useContext, useMemo, useState } from 'react';

const EOEContext = createContext();

const EOEContextProvider = ({ children }) => {
  const [city, setCity] = useState(null);
  const [cityName, setCityName] = useState(null);
  const [isIeDone, setIsIeDone] = useState(true);
  const [isIeMode, setIeMode] = useState('online');
  const [ieLang, setIeLang] = useState('en');
  const [country, setCountry] = useState('IN');
  const [seatCategory, setSeatCategory] = useState(false);

  // console.log('context city ==>', city);
  const value = useMemo(
    () => ({
      city,
      setCity,
      cityName,
      setCityName,
      isIeDone,
      setIsIeDone,
      isIeMode,
      setIeMode,
      ieLang,
      setIeLang,
      country,
      setCountry,
      seatCategory,
      setSeatCategory,
    }),
    [
      city,
      setCity,
      cityName,
      setCityName,
      isIeDone,
      ieLang,
      isIeMode,
      country,
      setCountry,
      seatCategory,
      setSeatCategory,
    ]
  );
  return <EOEContext.Provider value={value}>{children}</EOEContext.Provider>;
};

export const useEOEContext = () => {
  return useContext(EOEContext);
};

export { EOEContext, EOEContextProvider };

